import type { PostHog, Properties } from "posthog-js";

let client: PostHog | undefined;
let loading: Promise<void> | undefined;
const pending: { event: string; properties?: Properties; timestamp: Date }[] = [];

export function initializePostHog() {
  return loading ??= import("posthog-js").then(({ default: posthog }) => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
      api_host: "/ingest",
      ui_host: "https://us.posthog.com",
      defaults: "2026-01-30",
      capture_exceptions: true,
      debug: process.env.NODE_ENV === "development",
      disable_session_recording: true,
      disable_surveys: true,
      enable_heatmaps: false,
      capture_performance: false,
      capture_dead_clicks: false,
      disable_scroll_properties: true,
      disable_web_experiments: true,
    });
    client = posthog;
    for (const { event, properties, timestamp } of pending.splice(0)) {
      posthog.capture(event, properties, { timestamp });
    }
  });
}

/** Keep custom events and their original times while the SDK is loading. */
export function captureEvent(event: string, properties?: Properties) {
  if (client) client.capture(event, properties);
  else pending.push({ event, properties, timestamp: new Date() });
}
